const zh = {
  sidebar: {
    community: '社区&楼宇管理',
    electricLock: '电控门锁管理',
    sipAccount: 'SIP账户管理',
    settings: '门禁系统配置',
    roomSip: '房间SIP账号设置',
    staffSip: '员工SIP账号设置',
    doorLock: '入口电控门锁设置',
    callCenter: '呼叫中心配置',
    ecardSetting: '电子名片设置',
  },
  'Failed to fetch SIP accounts': '获取SIP账户失败',
  'Username is required': '用户名是必填项',
  'Username must be at least 4 characters': '用户名长度4-20个字符',
  'Password is required': '密码是必填项',
  'Password must be at least 6 characters': '密码长度6-8个字符',
  'SIP account deleted successfully': 'SIP账户删除成功',
  'All Type': '所有类型',
  'All Status': '所有状态',
  Search: '搜索',
  'Number of Accounts': '已创建账户数量合计',
  Type: '类型',
  Status: '状态',
  'Assigned To': '分配状态',
  Creator: '创建者',
  'Create Date': '创建日期',
  Actions: '操作',
  WebRTC: 'WebRTC',
  SIP: 'SIP',
  Online: '在线',
  Offline: '离线',
  Assigned: '已分配',
  Unassigned: '未分配',
  Edit: '编辑',
  Delete: '删除',
  Create: '添加',
  Update: '更新',
  Username: '用户名',
  'Username Range': '用户名范围',
  Prefix: '前缀',
  From: '从',
  To: '到',
  'Prefix is required': '前缀是必填项',
  'From and To values must have the same number of digits': '从和到值必须具有相同的位数',
  'To value must be greater than From value': '到值必须大于从值',
  'SIP Domain': 'SIP服务器IP或域名',
  Password: '密码',
  'Max Contacts': '最大设备数',
  Category: '类别',
  Cancel: '取消',
  'Are you sure you want to delete account': '你确定要删除账号',
  'Delete Account': '删除账号',
  Account: '账号',
  'Create Account': '添加',
  'Edit Account': '编辑账号',
  'Number of Door Lock': '已添加门锁数量合计',
  'Lock Management': '门锁管理',
  Installed: '已安装',
  Uninstalled: '未安装',
  Refresh: '刷新',
  UUID: 'UUID',
  'Relay ID': '继电器ID',
  'Door ID': '入口ID',
  Address: '地址',
  'Install Date': '安装日期',
  'Lock created successfully': '门锁添加成功',
  'Failed to create lock': '添加门锁失败',
  'Lock updated successfully': '门锁更新成功',
  'Failed to update lock': '更新门锁失败',
  'Lock deleted successfully': '门锁删除成功',
  'Failed to delete lock': '删除门锁失败',
  'Failed to fetch locks': '获取门锁失败',
  'Are you sure you want to delete the lock "{{uuid}}"?': '确定要删除门锁 "{{uuid}}" 吗？',
  'Subscription Subject *': '订阅主题 *',
  'Publish Subject *': '发布主题 *',
  'Wifi Password': 'Wifi密码',
  'UUID is required': 'UUID是必填项',
  'Relay ID is required': '继电器ID是必填项',
  'Subscription Subject is required': '订阅主题是必填项',
  'Publish Subject is required': '发布主题是必填项',
  All: '所有',
  'Create Lock': '添加',
  Save: '保存',
  'Edit Lock': '编辑门锁',
  'Subscription Subject': '订阅主题',
  'Publish Subject': '发布主题',
  'Wifi Name': 'Wifi名称',
  Confirm: '确认',
  'SIP account removed successfully': 'SIP账号删除成功',
  'All SIP': '所有SIP',
  'Assigned SIP': '已分配SIP',
  'Unassigned SIP': '未分配SIP',
  'Community Name': '社区名称',
  'Institute Name': '机构名称',
  'Contact Name': '联系人姓名',
  'SIP Account': 'SIP账号',
  Remove: '删除',
  'Remove SIP Account': '删除SIP账号',
  'Are you sure you want to remove this SIP account?': '你确定要删除这个SIP账号吗？',
  'Select Community': '选择社区',
  'SIP account assigned successfully': 'SIP账号分配成功',
  'SIP Account Setting': 'SIP账号设置',
  'Select one from unassigned SIP List': '从SIP列表中选择一个SIP账号',
  'Select SIP Account': '选择SIP账号',
  'Select Building': '选择楼宇',
  'All Floor': '所有楼层',
  Floor: '楼层',
  'Room No.': '房间号',
  'Building Name': '楼宇名称',
  'Please select a SIP account': '请选择一个SIP账号',
  'Public Entrance': '公共入口',
  'Building Entrance': '楼宇入口',
  'Community List': '社区列表',
  'Lock UUID': '门锁UUID',
  'WebRTC Account': 'WebRTC账户',
  'All Locks': '所有门锁',
  'Lock Assigned': '门锁已分配',
  'Lock Unassigned': '门锁未分配',
  'WebRTC Assigned': 'WebRTC已分配',
  'WebRTC Unassigned': 'WebRTC未分配',
  'All WebRTC': '所有WebRTC',
  'Entrance Name': '入口名称',
  'Please select a webrtc account': '请选择一个WebRTC账号',
  'Please select a lock': '请选择一个门锁',
  'Select Webrtc Account': '选择WebRTC账号',
  'Select Lock': '选择门锁',
  Setting: '设置',
  'Select one from unassigned Webrtc List': '从列表中选择一个未分配的WebRTC账号',
  'Select one from unassigned Lock List': '从列表中选择一个未分配的门锁',
  'Community deleted successfully': '社区删除成功',
  Community: '社区',
  'Total Communities': '社区总数',
  'Total Buildings': '楼宇总数',
  'In Service': '服务中',
  'Total Rooms': '房间总数',
  Income: '收入合计',
  Active: '已启用',
  Inactive: '未启用',
  'Search communities...': '搜索社区...',
  '+ Create New': '添加',
  'Community ID': '社区ID',
  Room: '房间',
  'Service Time': '服务时间',
  Staff: '员工',
  'Delete Community': '删除社区',
  'Are you sure you want to delete this community? This action cannot be undone.':
    '你确定要删除这个社区吗？这个操作无法撤销。',
  Entrance: '入口',
  Building: '楼宇',
  Contract: '合同',
  'Start Service': '启用',
  'Stop Service': '停用',
  'Delete Successfully': '删除成功',
  'Add New': '添加新楼宇',
  Rooms: '房间',
  'Lock ID': '门锁ID',
  'Start Time': '开始时间',
  'End Time': '结束时间',
  'Delete Building': '删除楼宇',
  'Are you sure you want to delete this building? This action cannot be undone.':
    '你确定要删除这个楼宇吗？这个操作无法撤销。',
  'Contract ID': '合同ID',
  Amount: '金额',
  Due: '到期',
  'Create New': '添加',
  'Delete Contract': '删除合同',
  'Are you sure you want to delete this contract? This action cannot be undone.':
    '你确定要删除这个合同吗？这个操作无法撤销。',
  'Please fill in all required fields': '请填写所有必填字段',
  'Edit Building': '编辑楼宇',
  'Create New Building': '添加',
  'Building ID': '楼宇ID',
  'Building Address': '楼宇地址',
  longitude: '经度',
  latitude: '纬度',
  'Service Range (Meters)': '服务范围（米）',
  Contacts: '联系人',
  'Contacts Phone': '联系人电话',
  Email: '邮箱',
  'Edit Community': '编辑社区',
  'Create New Community': '添加',
  'Community Address': '社区地址',
  'Start date must be before end date': '开始日期必须早于结束日期',
  'Payment amount must be greater than 0': '支付金额必须大于0',
  'Contract created successfully': '合同创建成功',
  'Contract updated successfully': '合同更新成功',
  'Start Date': '开始日期',
  'End Date': '结束日期',
  'Payment Date': '支付日期',
  'Payment Amount': '支付金额',
  'Entrance updated successfully': '入口更新成功',
  'Entrance created successfully': '入口创建成功',
  'Entrance save error': '入口保存错误',
  'Edit Entrance': '编辑入口',
  'Create New Entrance': '添加',
  'Entrance ID': '入口ID',
  'Entrance Address': '入口地址',
  'Public service updated successfully': '社区服务更新成功',
  'Public service created successfully': '社区服务创建成功',
  'Public service save error': '社区服务保存错误',
  'Edit Public Service': '编辑社区服务',
  'Create New Public Service': '添加',
  'Institution Name': '机构名称',
  'Is Public': '是否公开',
  'Not Public': '不公开',
  'Room updated successfully': '房间更新成功',
  'Room created successfully': '房间创建成功',
  'Room save error': '房间保存错误',
  'Edit Room': '编辑房间',
  'Create New Room': '添加',
  'Room ID': '房间ID',
  'Room Number': '房间号',
  'Entrance deleted successfully': '入口删除成功',
  'Entrance delete error': '入口删除错误',
  'Delete Entrance': '删除入口',
  'Are you sure you want to delete this entrance? This action cannot be undone.':
    '你确定要删除这个入口吗？这个操作无法撤销。',
  'Select Location': '选择位置',
  'Public Service': '社区服务',
  'Public service deleted successfully': '社区服务删除成功',
  'Public service delete error': '社区服务删除错误',
  'Delete Public Service': '删除社区服务',
  'Are you sure you want to delete this public service? This action cannot be undone.':
    '你确定要删除这个社区服务吗？这个操作无法撤销。',
  'Select Floor': '选择楼层',
  'All Floors': '所有楼层',
  'Room No': '房间号',
  'Delete Room': '删除房间',
  'Are you sure you want to delete this room? This action cannot be undone.':
    '你确定要删除这个房间吗？这个操作无法撤销。',
  'End Service': '停止服务',
  'Service Time Error': '服务时间错误',
  Longitude: '经度',
  Latitude: '纬度',
  Download: '下載',
  'Entrance QR Code': '公共入口二維碼',
  'Building QR Code': '樓宇入口二維碼',
  'all building': '所有樓宇',
  'Invalid URL parameters': '無效的URL參數',
  'Call To': '呼叫',
  'Hang up': '掛斷',
  'Please connect to the network': '請連接網絡',
  'Call in progress': '通话进行中',
  'Call failed': '呼叫失敗',
  'Call connected': '呼叫連接',
  'Call Room': '呼叫房間',
  'Are you sure you want to call this number room?': '你確定要呼叫這個{{number}}房間嗎？',
  Call: '呼叫',
  'Checking microphone access...': '檢查麥克風訪問...',
  'Checking microphone...': '檢查麥克風...',
  'Please allow microphone access': '請允許麥克風訪問',
  'Microphone not found': '麥克風未找到',
  'Cannot access your microphone': '無法訪問您的麥克風',
  'Detecting your location...': '偵測您的位置...',
  'Verifying your location...': '驗證您的位置...',
  'Getting location...': '獲取位置...',
  'verifying location...': '驗證位置...',
  'Please allow location access': '請允許位置訪問',
  'Location verified': '位置驗證',
  'Exceeding the service distance': '超出服務距離',
  'Error checking location': '位置檢查錯誤',
  'Error checking microphone': '麥克風檢查錯誤',
  'Request Permission': '請求許可',
  'Request Open Door': '访客指引',
  'Connecting...': '連接中...',
  Connected: '已連接',
  Disconnected: '已斷開',
  Ready: '已準備就緒',
  'Registration Failed': '註冊失敗',
  'Calling...': '呼叫中...',
  Service: '服務',
  User: '用戶',
  lat: '緯度',
  long: '經度',
  'Door Name': '入口名稱',
  'Transfer Name': '轉帳名稱',
  'Transfer Address': '傳輸地址',
  'Transfer Password': '轉移密碼',
  roomNumber: '房间号',
  'If location and microphone usage permissions have not been granted, please refresh the page and re authorize!':
    '如果未授予位置和麥克風使用權限，請刷新頁面重新授權！',
  'Refresh page': '刷新頁面',
  'Call ends in': '剩余通话时长:',
  'Call ended due to timeout': '通话因超时而结束',
  'Call ended': '呼叫结束',
  bulk_create: '批量增加',
  'Bulk Create Account': '批量增加',
  'Successfully created count_SIP accounts': '成功创建 {{count_SIP}} 个SIP账号',
  voice_call: '语音通话',
  video_call: '视频通话',
  'Please input all required fields': '请输入所有必填字段',
  'Please input valid domain': '请输入有效的域名格式',
  'Please save the call center first': '请先保存呼叫中心',
  'Please select a category first': '请先选择一个类别',
  'Call Center Name': '呼叫中心名称',
  Agent: '代理',
  'Search call centers...': '搜索呼叫中心...',
  URL: '网址',
  'Access Domain Name': '访问域名',
  'Category List': '分类列表',
  'Agent List': '代理列表',
  No: '序号',
  'No result': '暂无数据',
  'Assigned Sip List': '已分配SIP列表',
  Duty: '职务',
  isPublic: '公开',
  Avatar: '头像',
  'Click to upload image': '点击上传图片',
  'Click to upload file': '点击上传文件',
  Name: '姓名',
  Gender: '性别',
  email: '邮箱',
  'Sip Account': 'SIP账号',
  category_name: '分类名称',
  'Agent Info': '代理信息',
  Male: '男',
  Female: '女',
  Yes: '是',
  no: '否',
  Preview: '预览',
  QRCode: '二维码',
  male: '男',
  female: '女',
  'Save Successfully': '保存成功',
  'Update Successfully': '更新成功',
  'Call Center QR Code': '呼叫中心二维码',
  'This category has agents assigned to it. Are you sure you want to delete it? All agents will be deleted from this category.':
    '这个分类有代理分配给它。你确定要删除它吗？所有代理将从该分类中删除。',
  'Delete Category': '删除分类',
  'Are you sure you want to delete this category? This action cannot be undone.':
    '你确定要删除这个分类吗？这个操作无法撤销。',
  'Delete Call Center': '删除呼叫中心',
  'Are you sure you want to delete this call center? This action cannot be undone.':
    '你确定要删除这个呼叫中心吗？这个操作无法撤销。',
  'This call center has categories assigned to it. Are you sure you want to delete it? All categories will be deleted from this call center.':
    '这个呼叫中心有分类分配给它。你确定要删除它吗？所有分类将从该呼叫中心中删除。',
  'Delete Agent': '删除代理',
  'Are you sure you want to delete this agent? This action cannot be undone.':
    '你确定要删除这个代理吗？这个操作无法撤销。',
  ECard: '电子名片',
  'ECard Info': '电子名片信息',
  'Delete ECard': '删除电子名片',
  'Are you sure you want to delete this ECard? This action cannot be undone.':
    '你确定要删除这个电子名片吗？这个操作无法撤销。',
  'ECard QR Code': '电子名片二维码',
  'Search ECards...': '搜索电子名片...',
  'This ecard is not public. Please contact the administrator to get the public ecard.':
    '这个电子名片不是公开的。请联系管理员获取公开的电子名片。',
  Department: '部门',
  Copy: '复制',
  'Copied to clipboard': '已复制到剪贴板',
  'Initiate Call': '发起呼叫',
  ConfirmCall: '确定',
  'Optimizing Network' : '优化网络中...',
  'Are you sure you want to call this number?': '你确认要呼叫{{number}}吗？',
  'ECard Loading...': '电子名片加载中...',
};

export default zh;
